var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveChartSize2X1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 21,
    rx: 3.5,
    fill: "#666666",
    stroke: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 26.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 26.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#9E9E9E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.98 61C11.98 60.664 12.008 60.356 12.064 60.076C12.12 59.788 12.216 59.516 12.352 59.26C12.496 59.004 12.692 58.764 12.94 58.54C13.196 58.308 13.52 58.088 13.912 57.88C14.192 57.72 14.456 57.58 14.704 57.46C14.952 57.332 15.172 57.208 15.364 57.088C15.556 56.96 15.704 56.824 15.808 56.68C15.92 56.536 15.976 56.372 15.976 56.188C15.976 56.012 15.928 55.848 15.832 55.696C15.736 55.544 15.592 55.424 15.4 55.336C15.208 55.24 14.976 55.192 14.704 55.192C14.488 55.192 14.288 55.22 14.104 55.276C13.928 55.332 13.764 55.408 13.612 55.504C13.468 55.592 13.336 55.692 13.216 55.804C13.096 55.908 12.992 56.012 12.904 56.116L12.076 55.168C12.156 55.072 12.28 54.964 12.448 54.844C12.624 54.716 12.832 54.592 13.072 54.472C13.32 54.344 13.6 54.24 13.912 54.16C14.224 54.072 14.564 54.028 14.932 54.028C15.452 54.028 15.896 54.116 16.264 54.292C16.632 54.46 16.912 54.696 17.104 55C17.304 55.296 17.404 55.632 17.404 56.008C17.404 56.304 17.344 56.564 17.224 56.788C17.112 57.012 16.964 57.212 16.78 57.388C16.596 57.556 16.4 57.704 16.192 57.832C15.992 57.952 15.804 58.06 15.628 58.156C15.316 58.308 15.044 58.448 14.812 58.576C14.588 58.704 14.396 58.832 14.236 58.96C14.076 59.08 13.944 59.208 13.84 59.344C13.736 59.472 13.648 59.628 13.576 59.812H17.536V61H11.98ZM22.5868 54.724L24.0748 56.872L24.1828 57.076L24.2908 56.872L25.7668 54.724H27.1948L24.9388 57.868L27.2188 61H25.7908L24.2908 58.864L24.1828 58.672L24.0748 58.864L22.5748 61H21.1468L23.4268 57.88L21.1708 54.724H22.5868ZM35.6492 59.812V61H31.0652V59.812H32.7692V55.624C32.6972 55.72 32.5852 55.82 32.4332 55.924C32.2812 56.028 32.1092 56.128 31.9172 56.224C31.7332 56.312 31.5452 56.384 31.3532 56.44C31.1612 56.496 30.9852 56.524 30.8252 56.524V55.288C30.9852 55.288 31.1692 55.24 31.3772 55.144C31.5852 55.048 31.7892 54.936 31.9892 54.808C32.1972 54.672 32.3732 54.544 32.5172 54.424C32.6612 54.296 32.7452 54.204 32.7692 54.148H34.1252V59.812H35.6492Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveChartSize2X1);
export default __webpack_public_path__ + "static/media/inactiveChartSize2x1.3725d8647a9c5a17475b75a5299e1812.svg";
export { ForwardRef as ReactComponent };